module.exports = __webpack_public_path__ + "static/media/settings_icon.6cf5a28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/settings_icon.png
// module id = 307
// module chunks = 0